export type ServiceAccount = {
  serviceAccountId: string;
  created: string;
  lastAltered: string;
  lastAlteredBy: string;
  serviceAccountName: string;
  serviceAccountOwner: string;
  description: string;
  networkPolicyName: string;
  isOrganizationAdmin: boolean;
  isSupport: boolean;
};

export type ServiceAccountSecret = {
  id: string;
  name: string;
  secret: string;
};

export const EMPTY_NETWORK_POLICY = "__EMTPY_NETWORK_POLICY__";
